import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, TwitterAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "For Firebase JS SDK v7.20.0 and later, measurementId is optional",
//   authDomain: "panelapi.firebaseapp.com",
//   projectId: "panelapi",
//   storageBucket: "panelapi.appspot.com",
//   messagingSenderId: "For Firebase JS SDK v7.20.0 and later, measurementId is optional",
//   appId: "For Firebase JS SDK v7.20.0 and later, measurementId is optional",
//   measurementId: "For Firebase JS SDK v7.20.0 and later, measurementId is optional"
// };

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
export const auth = getAuth(app);
const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: 'select_account',
});
export {provider};
export const Tprovider = new TwitterAuthProvider();



